import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import SubcategoriesForm from './SubcategoriesForm';
import privateView from '../../components/hocs/privateView';
import Analytics from '../../services/Analytics';

class SubcategoriesDetail extends Component {
	componentDidMount() {
		const { email } = this.props.injectedProps;
		Analytics.recordPageView('subcategory_detail', email, {
			url: window.location.href,
			location: this.props.location,
			match: this.props.match
		});
	}

	render() {
		return (
			<Container>
				<SubcategoriesForm
					edit
					title="Subcategory Detail"
					{...this.props}
				/>
			</Container>
		);
	}
}

const mapStateToProps = ({ auth: { isFetch, roles, isLogged, id, email } }) => ({
	guardData: { isFetch, roles, isLogged, id, email }
});

const enhance = connect(mapStateToProps);
export default enhance(privateView(SubcategoriesDetail));
